var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMultipleCollection(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#EBF9F5",
    width: 24,
    height: 24,
    rx: 4
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#01B37A",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.788 17.9a2.799 2.799 0 0 1-2.056-.846 2.799 2.799 0 0 1-.846-2.056V9.69a1.214 1.214 0 0 1-.784-.406 1.2 1.2 0 0 1-.316-.832v-1.1c0-.34.123-.633.371-.88.248-.248.54-.372.88-.372h5.501c.34 0 .633.124.88.371.248.248.372.541.372.88v1.1a1.2 1.2 0 0 1-.316.833c-.211.234-.473.369-.784.406v5.308c0 .807-.285 1.492-.853 2.056a2.806 2.806 0 0 1-2.05.846zm0-1.031c.44 0 .825-.133 1.155-.4.33-.265.546-.604.646-1.017H8.2a.494.494 0 0 1-.509-.509c0-.147.049-.27.145-.371a.482.482 0 0 1 .364-.151h1.458v-.826H8.2a.482.482 0 0 1-.364-.15.5.5 0 0 1-.145-.359.494.494 0 0 1 .509-.523h1.458v-.824H8.2a.482.482 0 0 1-.364-.152.517.517 0 0 1-.145-.37.494.494 0 0 1 .51-.51h1.457V9.703H5.931v5.295c0 .523.181.965.543 1.327.363.362.8.544 1.314.544zM16.64 17.9a2.799 2.799 0 0 1-2.055-.846 2.799 2.799 0 0 1-.846-2.056V9.69a1.214 1.214 0 0 1-.784-.406 1.2 1.2 0 0 1-.316-.832v-1.1c0-.34.124-.633.371-.88.248-.248.541-.372.88-.372h5.501c.34 0 .633.124.88.371.248.248.372.541.372.88v1.1a1.2 1.2 0 0 1-.316.833c-.211.234-.472.369-.784.406v5.308c0 .807-.284 1.492-.853 2.056a2.806 2.806 0 0 1-2.05.846zm0-1.031c.441 0 .826-.133 1.156-.4.33-.265.546-.604.647-1.017h-1.39a.494.494 0 0 1-.508-.509c0-.147.048-.27.144-.371a.482.482 0 0 1 .364-.151h1.458v-.826h-1.458a.482.482 0 0 1-.364-.15.5.5 0 0 1-.144-.359c0-.155.048-.281.144-.378a.494.494 0 0 1 .364-.144h1.458v-.825h-1.458a.482.482 0 0 1-.364-.152.517.517 0 0 1-.144-.37.494.494 0 0 1 .508-.51h1.458V9.703h-3.727v5.295c0 .523.181.965.543 1.327.363.362.8.544 1.314.544z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMultipleCollection);
export default __webpack_public_path__ + "static/media/multiple-collection.e661a84bf0efdce592400e1d6566f13a.svg";
export { ForwardRef as ReactComponent };